import React from 'react'
import PropTypes from 'prop-types';

function Reunion({reu, eliminarReunion}) {

    // const eliminarCita = id=>{

    // }

    return (
        <div className="reunion">
            <h4>{reu.nombreReunion}</h4>
            <h6>{reu.nombre}</h6>
            <p>{reu.motivo}</p>
            <small>Fecha : {reu.fecha} <strong> hora : {reu.hora}</strong></small>
            <button
               onClick = {()=>eliminarReunion(reu.id)}
            >Eliminar &times;</button>
        </div>
    )
}

Reunion.propTypes = {
    reu : PropTypes.object.isRequired,
    eliminarReunion : PropTypes.func.isRequired
}
  

export default Reunion
